<div class="flex flex-col gap-3">
  <!-- Toolbar with Filters -->
  <div class="flex justify-between items-center flex-wrap gap-3">
    <div class="text-lg font-semibold text-gray-800">
      Downloads Log
      @if (totalDownloads > 0) {
        <span class="text-sm font-normal text-gray-500 ml-2">({{ totalDownloads }} records)</span>
      }
    </div>

    <div class="flex items-center flex-wrap gap-2">
      <p-iconfield iconPosition="left">
        <p-inputicon class="pi pi-search"></p-inputicon>
        <input
          pInputText
          [(ngModel)]="downloadSearch"
          placeholder="Search user, computer..."
          (keyup.enter)="onDownloadFilterChange()"
          class="w-56 text-sm" />
      </p-iconfield>

      <p-select
        [(ngModel)]="selectedVersionFilter"
        [options]="versionFilterOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Version"
        [style]="{ 'min-width': '130px' }"
        (onChange)="onDownloadFilterChange()">
      </p-select>

      <p-select
        [(ngModel)]="selectedSourceFilter"
        [options]="sourceFilterOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Source"
        [style]="{ 'min-width': '140px' }"
        (onChange)="onDownloadFilterChange()">
      </p-select>

      <p-datepicker
        [(ngModel)]="downloadRangeDates"
        selectionMode="range"
        [readonlyInput]="true"
        placeholder="Date range"
        (onSelect)="onDownloadFilterChange()"
        [showIcon]="true">
      </p-datepicker>

      <p-button
        icon="pi pi-filter-slash"
        label="Clear"
        severity="secondary"
        (onClick)="clearDownloadFilters()">
      </p-button>

      <p-button
        label="Export CSV"
        icon="pi pi-file"
        severity="secondary"
        (onClick)="exportDownloadsCsv()">
      </p-button>
    </div>
  </div>

  <!-- Downloads Table -->
  <p-table
    [value]="downloads"
    [lazy]="true"
    (onLazyLoad)="onDownloadsPage($event)"
    [paginator]="true"
    [rows]="downloadPageSize"
    [totalRecords]="totalDownloads"
    [loading]="downloadsLoading"
    [rowsPerPageOptions]="[25, 50, 100]">
    <ng-template #header>
      <tr>
        <th style="width: 15%">Date / Time</th>
        <th style="width: 10%">Version</th>
        <th style="width: 13%">Source</th>
        <th style="width: 22%">User</th>
        <th style="width: 18%">Computer / OS User</th>
        <th style="width: 12%">Updated From</th>
        <th style="width: 10%">IP Address</th>
      </tr>
    </ng-template>
    <ng-template #body let-item>
      <tr>
        <td class="text-sm text-gray-700">
          {{ item.downloadedAtUtc | date:'medium' }}
        </td>
        <td>
          <p-tag
            [value]="'v' + item.version"
            severity="info"
            [rounded]="true">
          </p-tag>
        </td>
        <td>
          <p-tag
            [value]="getDownloadSourceLabel(item.source)"
            [severity]="getDownloadSourceSeverity(item.source)"
            [rounded]="true">
          </p-tag>
        </td>
        <td>
          <div class="font-medium text-gray-900">{{ formatUser(item) }}</div>
        </td>
        <td class="text-sm text-gray-700">
          {{ formatComputer(item) }}
        </td>
        <td>
          @if (item.installedVersion) {
            <span class="text-sm font-medium text-blue-600">v{{ item.installedVersion }}</span>
          } @else {
            <span class="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded">New Install</span>
          }
        </td>
        <td class="text-xs font-mono text-gray-500">
          {{ item.ipAddress || '—' }}
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="7" class="text-center py-8">
          <div class="flex flex-col items-center justify-center text-gray-400">
            <i class="pi pi-download text-3xl mb-2"></i>
            <p class="text-sm font-medium text-gray-500 m-0">No download events found</p>
            <p class="text-xs text-gray-400 m-0 mt-1">Events will appear here as users install or update the plugin.</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-toast></p-toast>
